module.exports = __webpack_public_path__ + "media/momenta_en.c5656cf4.mp4";